import loadable from '@/utils/loadable';

export const AuthenticatedApp = loadable(() => import('./AuthenticatedApp'));
